export const pageParamName = 'page';

export const itemsPerPageParamName = 'itemsPerPage';

export const orderByParamName = 'orderBy';

export const alphabetFilterParamName = 'alphabet';

export const searchFilterParamName = 'search';

export const glossaryNameFilterParamName = 'name';

export const accessoriesPageParamName = 'accessoriesPage';

export const productsParamName = 'products';
